import * as $http from 'axios'

async function sendMetaTransition(eventName) {
    // 서버 사이드에서 전환 API 호출
    try {
        const userAgent = navigator.userAgent

        const fbc = localStorage.getItem('_fbc') || document.cookie.split('; ').find(row => row.startsWith('_fbc='))
        const fbp = localStorage.getItem('_fbp') || document.cookie.split('; ').find(row => row.startsWith('_fbp='))
        // console.log('fbc', (fbc && fbc.indexOf('=') === -1) ? fbc : fbc ? fbc.split('=')[1] : null)
        // console.log('fbp', (fbp && fbp.indexOf('=') === -1) ? fbp : fbp ? fbp.split('=')[1] : null)
        const userData = {
            client_user_agent: userAgent,
            fbc: fbc && fbc.indexOf('=') === -1 ? fbc : fbc ? fbc.split('=')[1] : null,
            fbp: fbp && fbp.indexOf('=') === -1 ? fbp : fbp ? fbp.split('=')[1] : null,
        }
        const DEVICE_ID = localStorage.getItem('DEVICE_ID') ? localStorage.getItem('DEVICE_ID').toString() : null

        const response = await $http.post('v2/signup_funnels/send_meta_api', {
            eventName: eventName,
            eventSourceUrl: window.location.href,
            userData: userData,
            device_id: DEVICE_ID,
        })

        if (response) {
            console.log('Success sending data to Meta')
        }
    } catch (error) {
        console.error('Error sending data to Meta:', error)
    }
}

export { sendMetaTransition }
